export const PUNUB_CONFIG_GET_REQUESTED = 'PUNUB_CONFIG_GET_REQUESTED';
export const PUNUB_CONFIG_GET_SUCCEED = 'PUNUB_CONFIG_GET_SUCCEED';
export const PUNUB_CONFIG_GET_FAILED = 'PUNUB_CONFIG_GET_FAILED';

export const PUNUB_GRANT_TOKEN_REQUESTED = 'PUNUB_GRANT_TOKEN_REQUESTED';
export const PUNUB_GRANT_TOKEN_SUCCEED = 'PUNUB_GRANT_TOKEN_SUCCEED';
export const PUNUB_GRANT_TOKEN_FAILED = 'PUNUB_GRANT_TOKEN_FAILED';

export const PUBNUB_INIT = 'PUBNUB_INIT';
export const PUBNUB_DESTROY = 'PUBNUB_DESTROY';
